import React from 'react';

export const useAnchor = () => {
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const [anchor, setAnchor] = React.useState<null | HTMLElement>(null);

  // a workaround to update anchor value
  React.useEffect(() => {
    setAnchor(anchorRef.current);
  }, []);

  const getAnchorRef = React.useCallback(() => {
    return anchor || null;
  }, [anchor]);

  return { anchorRef, getAnchorRef };
};
